import { OverlayToaster } from '@blueprintjs/core';

let BOSToasterRef;
const BOSToaster = () => {
  return <OverlayToaster ref={(ref) => (BOSToasterRef = ref)} />;
};

export { BOSToaster, BOSToasterRef };
